"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Clone rect
 *
 * @param  {Object}  rect
 * @return {Object} cloned rect
 */

var copy = function copy(rect) {
  return Object.assign({}, rect);
};

var _default = copy;
exports["default"] = _default;